
export let czMessages ={

  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Heslo",
  "remember":"Zapamatuj si mě",
  "forget":"Zapomenuté heslo?",
  "sign in":"Přihlásit se",
  "login":"Login",
  "sign up now":"Zaregistrovat se nyní",
  "apply":"Založit si účet",
  "contact us":"Kontaktujte nás",
  "Privacy Policy":"Zásady ochrany osobních údajů",
  "Terms of Use":"Podmínky užití",
  "copyright":"Autorská práva © 2021 Medtrum Technologies Inc. Všechna práva vyhrazena.",

  "chooseLang":"Zvolte Vaši zemi a jazyk",
  "asia":"Asie",
  "europe":"Evropa",

  "applyHcp":"Založit si účet poskytovatele zdr. péče",
  "sign up":"Zaregistrovat se",
  "Patient":"Pacient",
  "Caregiver":"Poskytovatel zdr. Péče",
  "Email":"Email",
  "Mobile":"Mobil",
  "Enter email":"Zadejte email adresu",
  "Enter mobile":"Zadejte mob. číslo",
  "Verification":"Verifikační kód",
  "Invitation":"Invitation code",
  "full name":"Zadejte své celé jméno",
  "Enter pass":"Zadejte heslo",
  "org":"Společnost/Organizace",
  "Register":"Register",
  "send":"Zaslat",
  "agree":"Přečetl jsem si a souhlasím se Zásadami ochrany ",
  "privacy":" ochrany osobních údajů ",
  "and" :"a ",
  "use":"Podmínkami užití.",
  "errtip1-1":"Musíte zadat platnou email adresu, která se ",
  "errtip1-2":"stane Vaším Medtrum uživ. jménem.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Nesprávný verifikační kód",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Nesprávné uživ. Jméno",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Please enter your organization.",

  "errp1":"Heslo musí obsahovat alespoň 3 typy následujících znaků: ",
  "errp2":"velká, malá písmena, čísla a zvláštní znaky.",
  "errp3":"Heslo musí mít délku mezi 6-20 znaky.",
  "errp4":"Heslo musí být jiné než uživatelské jméno.",
  "errp5":"Heslo s 3 po sobě jdoucími čísly je neplatné. (Např.: 123,321).",
  "errp6":"Heslo s 3 po sobě jdoucími písmeny je neplatné. (Např.: abc,cba).",
  "errp7":"Heslo nesmí obsahovat mezeru.",


  "Find account":"Znovu získat heslo",
  "Enter username":"Prosím zadejte Vaše uživ. jméno",
  "Next":"Dále",
  "Cancel":"Zrušit",
  "Back":"Zpět",
  "Enter veri":"Verifikační kód",
  "Verify notice":"Prosím vyhledejte verifikační kód zaslaný v emailu. ",
  "Create new":"Zadat nové heslo",
  "Create new notice":"Prosím zadejte nové heslo obsahující 6 nebo více znaků.",
  "New pass" :"Nové heslo",
  "Completed":"Hotovo",
  "Created":"Nové heslo zadáno",
  "Login Now":"Přihlásit se nyní",

  "Delete":"Vymazat",
  "New Patient":"Nový pacient",
  "Add Patient":"Přidat pacienta",
  "Filter":"Filtr",
  "Name":"Jméno",
  "Gender":"Pohlaví",
  "Age":"Věk",
  "Type":"Typ cukrovky",
  "Duration":"Doba trvání",
  "Connections":"Tvůrce účtu",
  "UploadTime":"Čas nahrání",
  "Year":"roky",
  "Years":"roky",
  "Month":"měsíců",
  "Month2":"Měsíc",
  "Months":"měsíců",
  "Invite":"Pozvat",
  "Invited":"Pozván/a",
  "All":"Vše",
  "Female":"Žena",
  "Male":"Muž",
  "Not Set":"Neurčeno",
  "Type 1":"Cukrovka typu 1",
  "Type 2":"Cukrovka typu 2",
  "Gestational":"Gestacionální cukrovka",
  "Prediabetes":"Prediabetes",
  "LADA":"Typ 1.5 LADA",
  "Apply":"Použít",
  "disUn":"Neupřesněná nemoc",
  "ageUn":"Neupřesněný věk",
  "genUn":"Neupřesněné pohlaví",
  "addP":"Přidat pacienta",
  "newP":"Nový pacient",
  "findP":"Najít pacienta",

  "GDRNF":"Neurčeno",
  "GDRF":"Žena",
  "GDRM":"Muž",
  "女":"Muž",

  "DBTNF":"Neurčeno",
  "DBT1":"Cukrovka typu 1",
  "DBT2":"Cukrovka typu 2",
  "DBTLADA":"Type 1.5 LADA",
  "DBTPRE":"Prediabetes",
  "DBTGEST":"Gestacionální cukrovka",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"Neurčeno",
  "unspecif":"Neurčeno",
  "register":"Pacient",
  "hcp":"Doktor",

  "BG":"Krevní glukóza",
  "CARB":"Sacharidy",
  "INS":"Injekce",
  "EXR":"Cvičení",
  "OTR":"Další",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Ketony v moči",
  "HEL":"HEL",
  "OTR1":"Další",
  "Loading":"Nahrávám",

  "home":"Domov ",
  "pID":"ID Pacienta",
  "fullName":"Celé jméno",
  "gender":"Pohlaví",
  "height":"Výška",
  "weight":"Váha",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Datum narození",
  "disType":"Typ cukrovky",
  "disDate":"Datum diagnózy",
  "Address":"Adresa",
  "Postcode":"PSČ",
  "Inpatient":"Hospitalizovaný pacient",
  "Yes":"Ano",
  "No":"Ne",
  "Pno":"Číslo hosp. pacienta",
  "Bno":"Číslo pac. postele",
  "create":"Vytvořit",
  "Telephone":"Tel.",

  "enterU":"Zadat uživ. Jméno (email)",
  "search":"Vyhledat",
  "noU":"Je vyžadováno uživ. jméno",
  "searchR":"Výsledky vyhledávání",
  "uername":"Uživ. jméno",
  "alias":"Přezdívka",
  "remove":"Odstranit",
  "viewG":"Zobrazit grafy",
  "sendR":"Zaslat žádost",
  "rSent":"Vaše žádost byla zaslána.",
  "cancelR":"Zrušit žádost",

  "VcodeTip1":"Nedoručeno? Prosím počkejte jednu minutu a ",
  "VcodeTip2":"zkuste to znovu.",
  "VcodeTip3":"Právě jsme zaslali verifikační kód na ",
  "Entercode":"Zadat kód",
  "Getcode":"Získat kód",

  "messages":"Zprávy",
  "profile":"Profil",
  "sign out":"Odhlásit se",
  "changeP":"Změnit heslo",
  "connection":"Spojení",

  "myP":"Můj profil",
  "Portrait":"Profil. foto",
  "Profession":"Povolání",
  "DPRONF":"Neurčeno",
  "DPROENDOCRIN":"Endokrinolog",
  "DPRODIABTRA":"Diabetolog",
  "DPRONURSE":"Zdr. sestra/bratr",
  "DPRODIATIT":"Dietetik",
  "DPROOTR":"Další Poskyt. zdrav. péče",
  "Organization":"Společnost",
  "Bio":"Životopis",
  "save":"Uložit",
  "oldPa":"Staré heslo",
  "newPa":"Nové heslo",
  "RePa":"Znovu zadat heslo",
  "forgetY":"Zapomenuté heslo?",
  "applyM":"Použít",
  "oldErr":"Staré heslo je nesprávné.",
  "EntTheSame":"Zadejte nové heslo znovu.",
  "EnterOld":"Zadejte straré heslo.",

  "pList":"Pacientův seznam",
  "connections":"Spojení",
  "settings":"Nastavení",
  "monitor":"Monitorace",
  "graphs":"Hlášení",
  "events":"Události",
  "records":"Záznamy",
  "qPrint":"Rychlý tisk",

  "sensorIn":"Senzor Info ",
  "timeOfLaRead":"Čas posledního senzor. měření hod",
  "tranSn":"SČ Vysílače",
  "status":"Stav",
  "sensorLife":"Zbývající životnost senzoru",
  "lastSenorRead":"Poslední senzorová hodnota",
  "TranBattery":"Baterie Vysílače",
  "sg":"SG",
  "alert":"Upozornění",
  "target":"Cíl",
  "hypo":"Hypo",
  "sensorGlucose":"Senzor. Glukóza",
  "calib":"Kalibrace",
  "newSen":"Nový senzor",
  "warm":"Příprava senzoru",
  "InsulinPump":"Inzulinová pumpa",
  "timeOfLaPump":"Čas posledních dat z pumpy",
  "pumpSN":"SČ Podstavy pumpy",
  "ReserviorLife":"Zbývající životnost zásob. náplasti",
  "InsulinLeft":"Zbývající inzulin",
  "basal":"Bazál",
  "bolus":"Bolus",
  "totalBasal":"Celodenní bazál",
  "lastBolus":"Poslední bolus",
  "activeInsulin":"Aktivní inzulin",
  "totalBolus":"Celodenní bolus",
  "tampBasal":"Dočasný bazál",
  "normalBolus":"Běžný bolus",
  "extendBolus":"Rozšířený bolus",
  "manualStop":"Manuální přerušení",
  "autoStop":"Auto přerušení",
  "auto suspend":"Auto přerušení",
  "stop":"Zastavení dávky",
  "newPatch":"Nová náplast",
  "tempBasal":"Dočasný bazál",
  "N":"B",
  "E":"R",
  "CN1":"KB",
  "CE":"KR",

  "staticSettings":"Nastavení hlášení",
  "dataSource":"Data k zobrazení",
  "unit":"Jednotka",
  "glucoseTarget":"Cílové rozmezí glukózy",
  "overall":"Celkem",
  "Hypoglycemia":"Hypoglykemie",
  "timePeriod":"Časové období",
  "postMeal":"Pojídelní analýza",
  "Breakfast":"Snídaně",
  "Lunch":"Oběd",
  "Dinner":"Večeře",
  "night":"Noc",
  "Before":"Předtím",
  "After":"Poté",
  "Low":"Nízká",
  "High":"Vysoká",
  "From":"Od",
  "To":"Do",
  "Hours":"Hodin",
  "Reset":"Obnovit výchozí nastavení",
  "RealTime":"Reálný čas",
  "uploaded":"Nahráno",
  "sensor":"Senzor",
  "pdmSN":"SČ ODM",
  "startTime":"Startovací čas",
  "endTime":"Konečný čas",
  "uploadTime":"Čas nahrání",
  "pdm":"ODM",
  "Uploaded":"Nahráno",
  "Patch Pump":"Patch pumpa",
  "overLapp":"Sessions overlapped",
  "showAlert":"Zobrazit upozornění",

  "dashboard":"Přístrojová deska",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Průměrný",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Průměrná denní dávka sacharidů",
  "dboard_exercise_avg":"Průměrná doba / Den",
  "dboard_sd":"SD",
  "dboard_num":"Mřížka",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Nejvyšší hodnota",
  "dboard_lowest_value":"Nejnižší hodnota",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Průměrná denní dávka",
  "dboard_SD":"Směrodatná odchylka",
  "dboard_daily_basal":"Denní basal",
  "dboard_daily_bolus":"Denní bolus",
  "dboard_avg_bolus_num":"Průměrná hodnota bolusu za den",
  "dboard_avg_suspend_time":"Průměrná doba odstavení",
  "dboard_avg_reservoir_usage":"Průměrná spotřeba rezervy",
  "dboard_days":"days",

  "dboard_manual_bolus":"Manuální bolus (Objem/za den)",
  "dboard_normal":"-Normální",
  "dboard_extend":"-Rozšířený",
  "dboard_combo":"-Kombinace",

  "dboard_bolus_calculator":"Kalkulačka Bolusu (Objem/ za den)",
  "dboard_food_bolus":"-Kalkulačka bolusu z jídla",
  "dboard_corr_bolus":"-Kalkulačka správného množství bolusu",
  "dboard_override_add":"-Přepsání (+)",
  "dboard_override_sub":"-Přepsání (-)",

  "dboard_report":"Přístrojová deska zprávu",

  "daily":"Denní souhrn",
  "date":"Datum",
  "print":"Tisk",
  "carbs":"Sacharidy",
  "exercise":"Cvičení",
  "heavy":"Těžké cvičení",
  "Medium":"Střední cvíčení",
  "Light":"Lehké cvičení",
  "dailyReport":"Denní souhrnné hlášení",
  "devices":"Zařízení",
  "tran":"Vysílač",
  "pumpBase":"Pods. pumpy",
  "HbA1c":"HbA1c",
  "statics":"Statistiky",
  "glucose":"Glukóza",
  "item":"Položka",
  "BG1":"GK",
  "SG1":"SG",
  "avgSD":"Průměr.(mmol/L)± Směr.odchylka",
  "avgSD1":"Průměr. ± Směr. odchylka",
  "min":"Minimum",
  "max":"Maximum",
  "ofRead":"# měření",
  "ofHypo":"# hypo. epizod/doba trvání(min)",
  "ofAlert":"# upozornění",
  "insulin":"Inzulin",
  "insulin2":"Inzulín",
  "totalDose":"CDD",
  "foodBolus":"Bolus k jídlu ",
  "Food+coor":"Food+corr",
  "calibBolus":"Opravný bolus",
  "durationStop":"Délka přerušení (min)",
  "ofPumpAlert":"# upozornění pumpy",
  "ofMeal":"# jídel ",
  "totalExerTime":"Celkový čas cvičení",
  "exerNum":"# cvičení",
  "avgInten":"Prům. intenzita",
  "target1":"Cíl",
  "high1":"Vysoká",
  "low1":"Nízká",
  "BG Reading":"měření GK",

  "dayByday":"Přehled den za dnem",
  "dayBydayRe":"Přehledové hlášení den za dnem",
  "period":"Časové období",

  "sensorOverlay":"Pokrytí senzoru",
  "set":"Nastavit",
  "setPeriod":"Nastavit čas. období",
  "Weekdays":"Pracovní dny",
  "Weekends":"Víkendy",
  "Mon":"Po",
  "Tue":"Út",
  "Wed":"St",
  "Thur":"Čt",
  "Thu":"Čt",
  "Fri":"Pá",
  "Sat":"So",
  "Sun":"Ne",
  "Average":"Průměr",
  "sensorOlRe":"Hlášení pokrytí senzoru",
  "Avg":"Průměr",
  "±SD":"±SD",
  "ofhypo":"# hypo epizod",
  "Everyday":"Každý den",

  "TrendAna":"Analýza vývoje",
  "TrendRe":"Hlášení analýzy vývoje",
  "sensorGlu":"Sensor Glucose ",
  "ofBGtest":"# GK testů",
  "Basics":"Základní",
  "static":"Statistiky",
  "Med":"Medián",
  "med":"median",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"Interkvartilové rozmezí (IQR)",
  "SD":"SD",
  "CV":"Variační koeficient",
  "SE1":"Směrodatná chyba průměru",
  "distri":"Distribuce",
  "stab":"Stabilita",
  "#high":"# měření vysoké GK",
  "#low":"# měření nízké GK",
  "aucBelow":"PPK pod limitem",
  "aucAbove":"PPK nad limitem",
  "bgRead":"měření GK",
  "total":"Celkem",
  "ofBolus":"# bolusů",
  "avgBolus":"Prům. bolus",
  "Dura1":"Doba trvání（min）",
  "Avg/Total":"Průměr/Celkem",
  "high":"Vysoká",
  "low":"Nízká",
  "#hypo":"# hypo epizod",
  "ofExer":"# cvičení",

  "logbook":"Záznamník",
  "dailyTotal":"Celkem za den",
  "High Glucose":"Vysoká glukóza",
  "Low Glucose":"Nízká glukóza",
  "No Active Patch":"Žádná aktivní náplast",
  "Missed Meal":"Zmeškané jídlo",
  "Multiple BG Readings":"Někólikanásobné měření GK",
  "Stop Patch":"Zastavit náplast",
  "Others":"Ostatní",
  "Other Events":"Další události",
  "logRe":"Hlášení záznamníku",

  "DeviceSetting":"Přehled nast. zařízení",
  "Insulin Pump":"Inzulinová pumpa",
  "MaxBasalRate":"Max. Baz. Dávka",
  "BasalPatterns":"Bazální schémata",
  "Selected Basal Pattern":"Vybraná bazální schémata",
  "Maximum Bolus":"Maximum Bolus",
  "Combo/Extended Bolus":"Kombi/Rozšířený Bolus",
  "BG Reminder":"Připomenutí GK",
  "Bolus Increment":"Bolusové zvýšení",
  "Bolus Calculator":"Bolus Kalkulátor ",
  "Active Insulin Time":"Čas akt. Inzulinu",
  "IC Ratios":"ISP Poměr ",
  "Insulin Sensitivity":"Inzulinová citlivost",
  "BG Target":"Cíl GK",
  "Bolus Reminder":"Připomenutí bolusu",
  "CGM":"Kontinuální monitorace glukózy",
  "CGM System":"Systém CGM",
  "Glucose Unit":"Glukózová jednotka",
  "Glucose Limits":"Glukózové limity",
  "Predicitive Alerts":"Plánovaná upozornění",
  "Rate Alerts":"Dávková upozornění",
  "type":"Typ ",
  "time":"Čas",
  "data":"Data",
  "Rate":"Rate",
  "Calibration Reminder":"Připomenutí kalibrace",
  "Calibration Repeat":"Opakovaná kalibrace",
  "Snooze":"Přestávka",
  "Audio Options":"Zvukové možnosti",
  "Confidence Reminder":"Potvrzení přijetí",
  "Backlight":"Podsvícení",
  "Sec":"sek",
  "Alarm Clock":"Budík",
  "Patch Expiration":"Expirace náplasti",
  "Sensor Expiration":"Expirace senzoru",
  "Hourly Max":"Hodinový Max",
  "Daily Max":"Denní Max",
  "Low Reservoir":"Nízký objem zásobníku",
  "Low Suspend":"Spo. Lim. Přerušení",
  "Predictive Low Suspend":"Plán. S.L. Přerušení",
  "Rise":"Vzestup",
  "Fall":"Sestup",
  "Auto Off":"Auto vyp",
  "Standard":"Standard",
  "Exercise":"Cvičení",
  "Holiday":"Prázdniny",
  "ProgramA":"Schéma A",
  "ProgramB":"Schéma B",
  "--":"--",
  "Insulin":"Inzulin",

  "SUSA":"Auto vyp",
  "SUSHM":"Překročena Max Hod. Dáv",
  "SUSDM":"Alarm: Překročena Max CDD",
  "SUSLSG":"Spo. Lim. Přerušení",
  "SUSPLSG":"Plán. S.L. Přerušení",
  "Pump Restarted":"Pumpa restartována",
  "Meter BG Now":"Nyní zadejte GK",
  "Sensor Exp in 2 Hours":"Senzor. Exp. za 2 hod.",
  "Sensor Exp in 6 Hours":"Senzor. Exp. za 6 hod.",
  "Sensor Exp in 30 Min":"Senzor. Exp. za 30 min.",
  "Sensor Calibration Error":"Chyba kalibrace senzoru",
  "Sensor Error":"Chyba senzoru",

  "Device Settings Report":"Hlášení nast. Zařízení",
  "24h Total":"24h/Celkem",
  "Device Settings at":"Device Settings at",
  "Start":"Start",
  "Combo/Ext Bolus":"Kombi/Rozš. Bolus",
  "Time Format":"Časový formát",
  "Device Options（CGM System)":"Nastavení zařízení (Systém CGM)",
  "Device Options（Insulin Pump)":"Nastavení zařízení (Inzulinová pumpa)",
  "Dispay Settings (Screen)":"Nastavení displeje (Obrazovka)",
  "Dispay Settings (Backlight)":"Nastavení displeje (Podsvícení)",
  "Graph Range":"Grafická škála",
  "Range":"škála",
  "Repeat":"Opakovat",
  "Glucose Alerts":"Glukózová upozornění",
  "Alert Silence":"Ztlumit upozornění ",

  "Create":"Vytvořit",
  "Event Filter":"Filtr událostí",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Ketony v moči",
  "Injection":"Injekce",
  "Other":"Další",
  "Event Type":"Typ události",
  "Details":"Detaily",
  "Notes":"Poznámky",
  "Source":"Zdroj",
  "edit":"Upravit",
  "Action":"Akce",
  "EventReport":"Přehledové hlášení událostí",
  "By Date":"Podle data",
  "By Category":"Podle kategorie",
  "Event Summary":"Přehled událostí",
  "No data":"Žádná data",
  "No1":"Žádná",
  "data1":"data",
  "#":"#",
  "BG Summary":"Přehled GK",
  "Carbs Summary":"Přehled Sacharidů",
  "Injection Summary":"Přehled injekcí",
  "Exercise Summary":"Přehled cvíčení",
  "Input Notes":"Vložit poznámku",

  "Profile":"Profil",
  "Complications":"Komplikace",
  "Concomitant diseases":"Průvodní nemoci",
  "Suggestion":"Návrh",
  "Coronary heart disease":"Ischemická choroba srdeční",
  "High blood lipids":"Vysoké krevní tuky",
  "High blood pressure":"Vysoký krevní tlak",
  "Kidney disease":"Ledvinová nemoc",
  "Neuropathy":"Neuropatie",
  "Obesity":"Obezita",
  "Peripheral arterial disease":"Periférní cévní onemocnění",
  "Retinopathy":"Retinopatie",
  "Smoking addiction":"Závislost na kouření",
  "Enter date":"Zadejte datum",
  "Enter suggestion":"Zadejte návrh",
  "Enter Notes":"Zadat poznámku.",
  "Select":"Vybrat",
  "Prescription":"Recept",
  "Medicine":"Lék",
  "Dose":"Dávka",
  "Enter medicine":"Zadat lék",
  "Enter dose":"Zadat dávku",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Zadat poznámku",
  "Add Content":"Max. délka je 1000 znaků.",
  "Other suggestions":"Další návrhy",
  "OK":"OK",
  "HCP":"Posk. Zdr. Péče",
  "Content":"Obsah",
  "Records Report":"Hlášení o záznamech",

  "Quick Print":"Rychlý tisk",
  "Quick Print Settings":"Nastavení rychlého tisku",
  "Select duration":"Vyberte délku trvání",
  "One Week":"Jeden týden",
  "One Month":"Jeden měsíc",
  "One Quarter":"Jeden kvartál",
  "End date":"Konečné datum",
  "Yesterday":"Včera",
  "Last Sunday":"Minulá neděle",
  "Last Saturday":"Minulá sobota",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Přizpůsobit",
  "Week Filter":"Týdenní filtr",
  "Select reports to print":"Vyberte hlášení k tisku",
  "Daily Summary":"Denní souhrn",
  "Day By Day Overview":"Přehled den za dnem",
  "Sensor Overlay":"Pokrytí senzotru",
  "Trend Analysis":"Analýza vývoje",
  "Logbook":"Záznamník",
  "Device Settings Review":"Přehled nastavení zařízení",
  "createReport":"Vytvořit zprávu",

  "Segment Analysis":"Analýza segmentu",
  "Sensor Glucose Profile":"Profil Senzor. Glukózy",
  "# of Boluses":"#  bolusů",
  "Bolus Insulin":"Bolus Inzulin",
  "Basal Pattern":"Bazál Schéma",
  "Segment Analysis Report":"Hlášení analýzy segmentů",
  "Avg Glucose":"Průměr. glukóza",
  "Below":"Pod",
  "In Target Range":"V cílovém rozmezí ",
  "Coefficient of variation":"variační koeficient",
  "% Time CGM Active":"% času aktivního CGM ",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Poznámka: Odhadovaná hladina A1C nenahrazuje laboratorní měření",


  "acceptTip":" Vám povolil dálkové sledování jeho/jejích zdr. údajů.",
  "cancelTip":" Vám pozastavil povolení k dálkovému sledování jeho/jejích zdr. údajů. V případě potřeby můžete požádat znovu.",
  "rejectTip":" Vám zamítl žádost o dálkové sledování.",
  "Read":"Přečíst",

  "Connection":"Spojení",
  "connections1":"Spojení",
  "Add Connection":"Přidat spojení",
  "SG":"SG",
  "Active Insulin":"Aktivní inzulin",
  "Stop following":"Přestat sledovat",
  "Enter username (email)":"Zadat uživ. Jméno (email)",
  "Search results":"Výsledky vyhledávání",
  "Send request":"Zaslat žádost",
  "View graphs":"Zobrazit grafy",
  "Agree":"Souhlasím",
  "Deny":"Zamítnout",
  "Remove":"Odstranit",
  "Cancel Requset":"Zrušit žádost ",
  "Remark":"Poznámka",

  "Warm up":"Příprava senzoru",
  "Monitoring":"Monitorace",
  "Transmitter Error":"Chyba vysílače",
  "Sensor Failure":"Selhání senzoru",
  "Sensor Expired":"Senzor expiroval",
  "Lost Sensor":"Senzor ztracen",
  "Not Calibrated":"Nekalibrováno",
  "Calibrating":"Kalibruji",
  "Calibration Needed":"Je zapotřebí kalibrace",
  "Calibration Error":"Chyba kalibrace",
  "Charging Battery":"Dobíjím baterii",
  "Battery Charged":"Baterie dobita",

  "To be filled":"K naplnění",
  "Filled with insulin":"Naplněn inzulinem",
  "Priming":"Priming",
  "Priming completed":"Priming dokončen",
  "Inserting needle":"Vkládám jehlu",
  "Patch activated":"Náplast aktivována",
  "Delivering Basal":"Doručuji bazál",
  "Exceeds Max 1 Hour Delivery":"Překročena Max Hod. Dáv",
  "Exceeds Max TDD":"Alarm: Překročena Max CDD",
  "Suspend":"Přerušit",
  "Occlusion Detected":"Zjištěna okluze",
  "Patch Expired":"Náplast expirovala",
  "Empty Reservoir":"Prázdný zásobník",
  "Patch Error":"Chyba náplasti",
  "Pump Base Error":"Chyba Podst. Pumpy",
  "Patch Battery Depleted":"Baterie náplasti prázdná",
  "Magnetic sensor not calibrated":"Magentický senzor nezkalibrován",

  "Patient Profile":"Profil pacienta",

  "On":"Zap",
  "on":"Zap",
  "Off":"Vyp",
  "off":"Vyp",

  "CORONARY_HEART_DISEASE":"Ischemická choroba srdeční",
  "HIGH_BLOOD_LIPIDS":"Vysoké krevní tuky",
  "HIGH_BLOOD_PRESSURE":"Vysoký krevní tlak",
  "KIDNEY_DISEASE":"Ledvinová nemoc",
  "NEUROPATHY":"Neuropatie",
  "OBESITY":"Obezita",
  "PERIPHERAL_ARTERIAL_DISEASE":"Periférní cévní onemocnění",
  "RETINOPATHY":"Retinopatie",
  "SMOKING_ADDICTION":"Závislost na kouření",

  "saveTip":"Uloženo úspěšně ",
  "changePaTip":"Vaše heslo bylo změněno",
  "enterEmTip":"Zadejte svou email adresu.",
  "verErrTip":"Nesprávný verifikační kód ",
  "chooseEventTip":"Zvolte události k tisku",
  "chooseDataTip":"Vybrat data k tisku",
  "dateWrongTip":"TKonečné datum nemůže být dřív než startovací datum",
  "infoWrongTip":"Prosím vyplňte všechna požadovaná pole.",
  "createdSuccssTip":"Vytvořeno úspěšně",
  "selectData":"Vybrat data k uložení",

  "acceSu":"Žádost o spojení přijata",
  "acceEr":"Přidání nového spojení selhalo",
  "rejeSu":"Zamítnutá žádost o spojení",
  "rejeEr":"Zamítnutí žádosti o spojení zamítnut",

  "userNotExist":"Toto uživ. jméno neexistuje",
  "Password incorrect":"Nesprávné heslo",
  "UserType incorrect":"Nesprávný typ uživatele",

  "registSuccess":"Váš účet byl úspěšně vytvořen.",
  "registFailed":"Registrace nového účtu selhala.",
  "sentSuccess":"Úspěšně zasláno",
  "sentFailed":"Zaslání selhalo",
  "Input error":"Špatné zadání",

  "deletePtip":"Jste si jisti vymazáním těchto pacientů?",
  "deleteEvents":"Jste si jisti vymazáním těchto událostí?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Jste si jisti tímto vymazáním?",
  "confirm":"Potvrdit",
  "deleteSuccess":"Úspěšné vymazání",
  "deleteFailed":"Smazání selhalo",
  "modifySuccess":"Úspěšně upraveno",
  "modifyFailed":"Úprava selhala",
  "createSuccess":"Úspěšné vytvoření",
  "createFailed":"Vytvoření selhalo",
  "editSuccess":"Úspěšně upraveno",
  "editFailed":"Úprava selhala",
  "Time overlapped":"Vámi vybraná vysílání se překrývají",

  "stopFollow":"Jste si jistí, že chcete přestat sledovat tohoto pacienta?",
  "CancelTip1":"Jste si jisti tímto spojením?",

  "Warning":"Připomenutí",
  "agreeConnect":"Pokud kliknete 'Souhlasím', přijímáte tak žádost o spojení. Vaše zdr. údaje  budou dostupné novému spojení.",
  "denyConnect":"Jste si jistí zamítnutím tohoto spojení? ",
  "deleteConnect":"Jste si jisti vymazáním tohoto spojení? Pokud jej vymažete, dané spojení si již nebude moci zobrazit Vaše data o zdr. stavu .",

  "Choose the events to print":"Zvolte události k tisku",
  "tryAgain":"Zkusit znovu",
  "username and password is required":"Je vyžadováno uživ. jméno",
  "A name is required":"Je vyžadováno jméno",
  "username is required":"Je vyžadováno uživ. jméno",
  "The date choose wrong":"Špatný výběr data",
  "Date no more than 14 days":"Nelze vybrat více než 14 dní",

  "CancelTip":"Jste si jistí zamítnutím tohoto spojení? ",
  "removeConnect":"Úspěšné vymazání",

  "dateErr1":"Nelze vybrat více než 90 dní",
  "dateErr2":"Konečné datum nemůže být dřív než startovací datum",

  "Not Filled":"Neurčeno",
  "Today":"Dnes",
  "duration":"Doba trvání",
  "interval":"Interval",
  "7 days":"7 dní",
  "14 days":"14 dní",
  "30 days":"30 dní",
  "90 days":"90 dní",
  "g":"g",

  "Sound+Vibrate":"Zvuk+Vibrace",
  "Sound":"Zvuk",
  "Vibrate":"Vibrace",
  "Silent":"Nerušit",
  "1":"Jednou",
  "2":"Denně",
  "noMes":"Žádné zprávy",
  "noConnect":"Žádná spojení",
  "Customize":"Přizpůsobit",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Led",
  "Feb":"Úno",
  "Mar":"Bře",
  "Apr":"Dub",
  "May":"Kvě",
  "Jun":"Čer",
  "Jul":"Čvc",
  "Aug":"Aug",
  "Sep":"Zář",
  "Oct":"Říj",
  "Nov":"Lis",
  "Dec":"Pro",
  "ApplyTip":" žádost o zobrazení vašich dat.",
  "noReadings":"Chyba senzoru",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Nahraná data",
  "daop_uploaded_data_text":"Data pochází z aplikace EasyTouch nebo EasyView iPad.",
  "daop_realtime_data":"Data v reálném čase",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(J)",
  "ins_unit2":"J",
  "basal_unit":"(J/H)",
  "basal_unit2":"J/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Slabá bat. náplasti",
  "Alerts_Patch_Battery_Depleted":"Prázdná bat. náplasti", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Nízký objem zásobníku", // update
  "Alerts_Empty_Reservoir":"Prázdný zásobník",
  "Alerts_Patch_Expiration_Advisory":"Výstraha. Exp. Náplasti",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Náplast expirovala", // update
  "Alerts_Patch_Error":"Chyba náplasti",
  "Alerts_Pump_Base_Error":"Chyba Podst. Pumpy",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Zjištěna okluze", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Alarm: Překročena Max CDD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Překročena Max Hod. Dáv",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Plán. S.L. Přerušení", // update
  "Alerts_Low_Suspend":"Spo. Lim. Přerušení",
  "Alerts_Auto_Off":"Auto vyp", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Senzor ztracen", // update
  "Alerts_Transmitter_Battery_Low":"Slabá baterie vysílače",
  "Alerts_Charge_Transmitter":"Nabijte vysílač",
  "Alerts_Sensor_Error":"Chyba senzoru", // update
  "Alerts_Transmitter_Error":"Chyba vysílače",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Selhání senzoru",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Nyní zadejte GK",
  "Alerts_Sensor_Exp_in_6_Hours":"Senzor. Exp. za 6 hod.",
  "Alerts_Sensor_Exp_in_2_Hours":"Senzor. Exp. za 2 hod.", // update
  "Alerts_Sensor_Exp_in_30_Min":"Senzor. Exp. za 30 min.",
  "Alerts_Sensor_Expired":"Senzor expiroval", // update
  "Alerts_Rapid_Rise":"Prudký vzestup",
  "Alerts_Rapid_Fall":"Prudký sestup",
  "Alerts_High_Predicted":"Hor. Lim. Přer.",
  "Alerts_Low_Predicted":"Níz. Lim. Přer.",
  "Alerts_High_Glucose":"Vysoká glukóza", // update
  "Alerts_Low_Glucose":"Nízká glukóza", // update
  "Alerts_Below_3.1_mmol/L":"Pod 3.1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Slabá baterie vysílače",

  "Alerts_PDM_Battery_Low":"Nízká baterie ODM",
  "Alerts_Replace_Battery":"Charge PDM Now", // update

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Upozornění",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pumpa",
  //"CGM":"CGM",
  "alert_Time":"Time",
  "alert_Type":"Type",

  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Doba v auto režimu",
  "t1221_Average_SG_SD":"Průměrná GS±SD",
  "t1221_Time_in_Target_Range":"Doba v cílovém rozmezí",
  "t1221_Time_above_Range":"Doba nad rozmezím",
  "t1221_Time_below_Range":"Doba pod rozmezím",
  "t1221_Auto_Basal_per_day":"Auto bazál (za den)",
  "t1221_Auto_Bolus_per_day":"Auto bolus (za den)",
  "t1221_Auto_Mode_Exits":"Ukončení auto režimu",
  "t1221_No_Sensor_readings":"Žádné údaje senzoru",
  "t1221_Max_Delivery":"Maximální podání",
  "t1221_Min_Delivery":"Minimální podání",
  "t1222_autoModeBasal":"Auto režim bazálu",
  "t1222_autoModeCorrBolus":"Auto režim korekčního bolusu",
  "t1222_autoSnack":"Auto svačina",
  "t1222_autoBreakfast":"Auto snídaně",
  "t1222_autoLunch":"Auto oběd",
  "t1222_autoDinner":"Auto večeře",
  "t1222_autoExercise":"Auto pohybová aktivita",
  "t1222_Snack":"Svačina",
  "t1222_Auto_Mode":"Auto režim",
  "t1222_Time_in_Auto_Mode":"Doba v auto režimu (%)",
  "t1222_Avg_SD":"Průměr (mmol/l)±SD",
  "t1222_Target_Range":"Cílové rozmezí(%)",
  "t1222_Above_Range":"Nad rozmezí(%)",
  "t1222_Below_Range":"Pod rozmezí(%)",
  "t1222_Auto_Mode_Exits":"# ukončení auto režimu",
  "t1221_Auto_Mode":"Auto režim",
  "t1222_auto_basal":"Auto bazál",
  "t1222_auto_bolus":"Auto bolus",
  "t0805_User_Management":"správa uživatelů",
  "t0805_Patient_Management":"Správa pacientů",
  "t0805_Operation_History":"Historie provozu",
  "t0805_User_List":"Seznam uživatelů",
  "t0805_User":"Uživatel",
  "t0805_Time":"Čas",
  "t0805_Operation_Type":"Typ operace",
  "t0805_Back":"Zpět",
  "t0805_Add":"Přidat",
  "t0805_Delete":"Vymazat",
  "t0809_Add_User":"Přidat uživatele",
  "t1028_Pattern_C":"Schéma C",
  "t1028_Pattern_D":"Schéma D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Nemoc",
  "t1029_Auto_Mode_Feature":"Funkce auto režimu",
  "t1029_Target_SG":"Cíl GS",
  "t1029_Auto_Meal_Handling":"Auto řízení jídla",
  "t1029_Total_Daily_Dose":"Celk. denní dávku",
  "t1029_Pump_Light":"Kontrolka pumpy",
  "t1029_Alerts_for_Hypo":"Výstrahy pro Hypo",
  "t1102_Out_of_Range":"Mimo dosah",
  "t1102_Command_Reminder":"Připomenutí příkazu",
  "t1102_Alarms_Alerts_on_APP":"Alarmy a upozornění na čerpadlo",
  "t1102_Alarms_on_App":"Alarmy na aplikaci",
  "t1102_Alerts_on_App":"Upozornění na aplikaci",
  "t1102_Factory_Calibration":"Tovární kalibrace",
  "t1102_Alerts_for_Low":"Upozornění pro nízké",
  "t1102_Alerts_for_High":"Upozornění pro vysoké",
  "t1102_Alerts_for_Others":"Upozornění pro ostatní",
  "t1102_Adjustment":"Nastavení",
  "t1102_Suggested":"Doporučeno",
  "t1103_Glucose":"Glukóza",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Inzulin",
  "t1103_Carbs":"Sacharidy",
  "t1103_Exercise":"Cvičení ",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Cílový rozsah",
  "t1103_Overall_Tine_In_Range":"Přehled: čas v rozsahu",
  "t1103_Basal":"Bazál",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Bazál & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto režim",
  "t1103_Time_below_range":"Čas pod cílovým rozsahem",
  "t1103_Time_above_range":"Čas nad cílovým rozsahem",
  "t1103_Time_in_target_range":"Čas v cílovém rozsahu",
  "t1103_Incorrect_Password":"Nesprávné heslo, zbývá $1 pokus, zadejte prosím správné heslo.",
  "t1103_Incorrect_locked":"Neúspěšné pokusy překračují limit, účet byl uzamčen. Zkuste to prosím znovu za $1 minut.",
  "t1104_The_data_is_from":"Data pochází z aplikace EasySense nebo EasyPatch.",
  "t1104_Privacy_Policy":"Ochrana osobních dat a podmínky pro užívání",
  "t1104_updated_privacy_policy":"Aktualizovali jsme vaši ochranu osobních dat a podmínky pro uživatele. Před použitím EasyPatch si, prosím, pečlivě přečtěte nové podmínky a potvrďte souhlas.",
  "t1104_Disagree":"Nesouhlas",
  "t1104_Agree":"Souhlasím",
  "t1105_Upload_History":"Historie nahrávání",
  "t1105_Delete_Data":"Smazat data",
  "t1105_Target_Range":"Cílový rozsah",
  "t1105_request_to_view_your_data":"$1 požadavek na zobrazení vašich dat.",
  "t1105_Recent_Updates":"Nedávné aktualizace",
  "t1108_No_data":"Žádná data",
  "t1108_Pump_Bash_SN":"SČ Pods. pumpy",
  "t1108_Transmitter_SN":"SČ Vysílače",
  "t1112_Normal_Glucose":"Normální Glukóza",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manuální bolus nebo Modifikovaný bolus",
  "t1112_Auto_Mode_Started":"Auto režim začal",
  "t1112_Auto_Mode_Exit":"Ukončení auto režimu",
  "t1112_Normal_Bolus":"Běžný bolus",
  "t1112_Extended_Bolus":"Rozšířený bolus",
  "t1112_Combo_Bolus":"Kombinovaný bolus",
  "t1112_Carbs":"Sacharidy",
  "t1112_Glucose":"Glukóza",
  "t1112_BG":"GK",
  "t1112_Audio":"Zvuk",
  "t1112_Tone":"Tón",
  "t1112_Audio_Options":"Zvukové možnosti",
  "t1112_Weight_Unit":"Hmotnostní Jednotka",
  "t1112_Height_Unit":"Jednotka Výšky",
  "t1112_Not_available":"Není Dostupný",
  "t1112_Number":"Číslo",
  "t1112_days":"# dny",
  "t1112_min":"min",
  "t1113_days":"dny",
  "t1215_Security":"Bezpečnostní",
  "t1215_MFA":"Vícefaktorové ověřování (MFA)",
  "t1215_Enter_verification_code":"Vložte ověřovací kód",
  "t1215_Multi_factor_ON":"Vícefaktorové ověřování je ZAPNUTO. Ověřovací kód byl odeslán na adresu $1 Odešlete prosím ověřovací kód.",
  "t1215_Verification_code_incorrect":"Nesprávný verifikační kód",
  "t1215_Show_Glucose_Value":"Zobrazit hodnotu glukózy",
  "t1221_enter_verification_code":"Zadejte 6místný ověřovací kód odeslaný na číslo $1.",
  "t1221_Verification_Success":"Úspěšně ověřeno",
  "t1222_We_will_only_process":"Vaše zdravotnická data zpracováváme pouze prostřednictvím aplikace Medtrum/webu s vaším souhlasem. ",
  "t1222_If_you_are_under_years":"Pokud máte méně než 16 let, budete potřebovat souhlas svého rodiče nebo zákonného zástupce k registraci v této aplikaci. .",
  "t1221_register_cn":"Máte právo nenahrávat do aplikace žádná data zařízení. V takovém případě nebudou data přístupná ostatním. Pokud se rozhodnete neregistrovat se v aplikaci Medtrum nebo na webových stránkách, jediný záznam vašich zdravotních údajů je na samotném zařízení. ",
  "t1221_register_eu":"Pokud se rozhodnete zaregistrovat svůj účet Medtrum a přistupovat k naší aplikaci pomocí účtu, budou zdravotní údaje zaznamenané v aplikaci nahrány na náš server v Evropě a budou uchovávány po dobu 2 let. Máte právo nenahrávat do aplikace žádná data zařízení. V takovém případě nebudou data přístupná ostatním. Pokud se rozhodnete neregistrovat se v aplikaci Medtrum nebo na webových stránkách, jediný záznam vašich zdravotních údajů je na samotném zařízení.",
  "t1221_register_follow":"Vaše zdravotnická data zpracováváme pouze prostřednictvím aplikace Medtrum/webu s vaším souhlasem.",
  "t1222_Terms_of_Use":"s podmínkami užití společnosti Medtrum",
  "t1222_Privacy_Policy":"se zásadami ochrany o osobních údajích společnosti Medtrum",
  "t1222_Create_Account":"Vytvořit účet",
  "t1222_Back":"Zpět",
  "t1222_Verify_your_account":"Ověřte svůj účet",
  "t1222_please_check_your_account":"Ověřovací kód zašleme na adresu $1, zkontrolujte prosím svůj účet.",
  "t1222_I_Agree_to":"Souhlasím $1",
  "t1223_Invalid_Verification_Code":"Neplatný ověřovací kód. Prosím zkuste to znovu.",
}

//export default {
//  czMessages
//}



// WEBPACK FOOTER //
// ./src/lang/cz.js